/**
 *	First thing we need to require is the es6 polyfill. Please do not
 *	put anything above this line.
 */
import ES5 from 'es5-shim';
import Console from 'console-polyfill';
import Babel from 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import FastClick from 'fastclick';
import { Router, match, browserHistory } from 'react-router';
import { Session } from 'acast-reactor';
import { getCookie } from 'acast-www-uikit/dist/components/cookie-consent/utils';
import Routes from 'client/routes';
import Queries from 'client/queries';
import Features from 'client/features';
import RouteStore from 'client/stores/route';
import RAFPoly from 'client/vendor/raf-polyfill';
import DateNowPoly from 'client/vendor/date-now-polyfill';
import { initFacebookPixel, initGoogleAnalytics } from 'client/services';

/**
 *	Next up, we will define our global DEBUG flag on the window before
 *	loading any other scripts.
 */
if (location.host.match('(systemtest|localhost|-stage.azurewebsites.net)')) {
  window.ACAST_DEBUG = true;
}

/**
 *	We are now ready for any client-side code. You should now start editing
 *	the routes file to add your custom routes.
 */
document.addEventListener('DOMContentLoaded', () => {
  Session.create('queries', {
    queries: window.__QUERIES__,
  });

  let history = browserHistory;
  RouteStore.history = history;

  const node = document.querySelector('#react-app');

  // We're using the `match` method on the client as well since we need
  // to let react-router know that we're doing code-splitting. This prevents
  // the application from a "blink"/"flash" on every page-load. This is poorly
  // documented as always with react-router.
  match({ history, routes: Routes }, (error, redirect, props) =>
    ReactDOM.render(<Router {...props} />, node)
  );
});

window.addEventListener('load', () => {
  FastClick.attach(document.body);
});

const { performanceCookies = false } = getCookie() || {};
initGoogleAnalytics(performanceCookies);
initFacebookPixel(performanceCookies);



// WEBPACK FOOTER //
// ./client/index.es6